module.exports = __webpack_public_path__ + "img/韩旭.a5bb078f.jpg";